module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('deleted-page-component', [_c('div', {
    staticClass: "content-container"
  }, [_c('p', {
    staticClass: "text"
  }, [_vm._v("\r\n            " + _vm._s(_vm.userName) + " is not avaliable anymore. Hit the button below and continue journey with " + _vm._s(_vm.dealerName) + " or get new Digital Business Card\r\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "expert"
  }, [_vm._v("Your new expert is")]), _vm._v(" "), (_vm.isExpert) ? _c('div', {
    staticClass: "user-block"
  }, [_c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.avatar,
      "alt": "Salesperson avatar"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_c('span', [_vm._v(_vm._s(_vm.firstName))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.lastName))])])]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "button-primary",
    attrs: {
      "href": _vm.dbcLink
    }
  }, [_vm._v("Open new Digital Business Card")]), _vm._v(" "), _c('span', {
    staticClass: "annotation"
  }, [_vm._v("You will recieve the text message with the valid link")])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-293b27a6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-293b27a6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/src/pages/deleted/reassigned.vue
// module id = 754
// module chunks = 0